export enum Winners {
  PLAYER = 'PLAYER',
  BANKER = 'BANKER',
  TIE = 'TIE',
}
